export enum ValidateIsNan {
  NAN = 'NaN',
}
